export interface TimesheetRoot {
  '@odata.context': string;
  value: Timesheet[];
}

export interface Timesheet {
  '@odata.etag': string;
  timesheetNo: string;
  employeeNo: string;
  fullName: string;
  startingDate: string;
  endingDate: string;
}

export interface TimesheetLineRoot {
  '@odata.context': string;
  value: TimesheetLine[];
}

export interface TimesheetLine {
  '@odata.etag': string;
  entryNo: number;
  timesheetNo: string;
  projectNo: string;
  phaseNo: string;
  taskNo: string;
  decription: string;
  activityDate: string;
  totalTime: number;
  billable: boolean;
  billableType: string;
  userID: string;
  employeeNo: string;
  comment: string;
}

export interface InsertTimesheetHeaderRequestParams {
  employeeNo: string;
  startingDate: string;
  endingDate: string;
}

export interface InsertTimesheetHeaderResponse {
  '@odata.context': string;
  '@odata.etag': string;
  timesheetNo: string;
  employeeNo: string;
  fullName: string;
  startingDate: string;
  endingDate: string;
}

export interface InsertTimesheetLineRequestParams {
  timesheetNo: string;
  activityDate: string;
  projectNo: string;
  phaseNo: string;
  taskNo: string;
  totalTime: number;
  billable: string; // default value 'True'
  comment: string;
  entryNo?: number;
}

export interface InsertTimesheetLineResponse {
  '@odata.context': string;
  '@odata.etag': string;
  entryNo: number;
  timesheetNo: string;
  projectNo: string;
  phaseNo: string;
  taskNo: string;
  decription: string;
  activityDate: string;
  totalTime: number;
  billable: boolean;
  billableType: string;
  userID: string;
  employeeNo: string;
  comment: string;
}

export interface DeleteTimesheetLineRequestParams {
  entryNo: number;
  timesheetNo: string;
}

export interface TimesheetLinesByDate {
  date: string;
  totalHours: number;
  timesheetLines: TimesheetLine[];
}

export interface TimesheetLinesByWeek {
  startDateOfWeek: string;
  endDateOfWeek: string;
  totalHours: number;
  timesheetLinesByDay: TimesheetLinesByDate[];
}

export interface TimesheetLinesByMonth {
  month: string;
  year: string;
  totalHours: number;
  timesheetLinesByDay: TimesheetLinesByDate[];
}

export class TimesheetsLinesDomain {
  newTimesheetLines: TimesheetLine[];

  constructor(newTimesheetLines?: TimesheetLine[]) {
    this.newTimesheetLines = newTimesheetLines ?? [];
  }

  toJsonList(currentTimesheetLines: Record<string, TimesheetLine>): Record<string, TimesheetLine> {
    this.newTimesheetLines.forEach((timesheetLine) => {
      if (timesheetLine.entryNo) {
        currentTimesheetLines[timesheetLine.entryNo] = timesheetLine;
      }
    });

    return currentTimesheetLines;
  }

  toList(currentTimesheetLines: Record<string, TimesheetLine>): TimesheetLine[] {
    return Object.values(currentTimesheetLines);
  }
}
